const filterListModalFilterExpiredServices = {
  filter: 'FILTERS',
  clear: 'clean filters'
};

export default filterListModalFilterExpiredServices;
